import React, { useState } from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { NavLink, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import '../index.css';

import logo from '../assets/logo.png';

const CustomNavbar = () => {
    const [expanded, setExpanded] = useState(false);

    // Animation variants
    const navItemVariants = {
        hidden: { opacity: 0, y: -20 },
        visible: (i) => ({
            opacity: 1,
            y: 0,
            transition: { delay: i * 0.1, duration: 0.5, ease: "easeOut" }
        })
    };

    return (
        <>
            <Navbar
                expanded={expanded}
                expand="lg"
                variant="dark"
                className="sticky-top py-3"
                style={{
                    zIndex: 1000,
                    background: 'rgba(5, 5, 5, 0.8)',
                    backdropFilter: 'blur(10px)',
                    borderBottom: '1px solid rgba(255, 215, 0, 0.1)'
                }}
                onToggle={() => setExpanded(!expanded)}
            >
                <Container fluid>
                    <Navbar.Brand as={Link} to="/" onClick={() => setExpanded(false)} className="d-flex align-items-center">
                        <motion.div
                            initial={{ scale: 0, rotate: -180 }}
                            animate={{ scale: 1, rotate: 0 }}
                            transition={{ type: "spring", stiffness: 260, damping: 20 }}
                            className="position-relative me-2"
                        >
                            <img
                                src={logo}
                                width="42"
                                height="42"
                                className="d-inline-block align-top"
                                alt="Thalai Nagaram RP Logo"
                                style={{ filter: 'drop-shadow(0 0 8px rgba(0,243,255,0.6))', objectFit: 'contain' }}
                            />
                        </motion.div>
                        <motion.span
                            initial={{ opacity: 0, x: -20 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ delay: 0.2 }}
                            className="fw-bold align-middle d-inline"
                            style={{
                                fontFamily: 'Orbitron, sans-serif',
                                letterSpacing: '2px',
                                color: '#fff',
                                textShadow: '0 0 10px rgba(255, 215, 0, 0.5)'
                            }}
                        >
                            THALAINAGARAM <span style={{ color: 'var(--neon-gold)' }}>RP</span>
                        </motion.span>
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" style={{ borderColor: 'rgba(255, 215, 0, 0.3)' }} />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="ms-auto align-items-center">
                            {['Home', 'Info', 'Rules', 'Jobs', 'Community', 'Team', 'FAQ'].map((item, i) => {
                                const path = item === 'Home' ? '/' : `/${item.toLowerCase()}`;
                                return (
                                    <motion.div custom={i} initial="hidden" animate="visible" variants={navItemVariants} key={item}>
                                        <Nav.Link as={NavLink} to={path} onClick={() => setExpanded(false)} className="mx-3">
                                            {item}
                                        </Nav.Link>
                                    </motion.div>
                                )
                            })}
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </>
    );
};

export default CustomNavbar;
